import "./PopUpDialog.css";

import classNames from "classnames";
import { MouseEventHandler, ReactChild } from "react";

const PopUpDialog = ({
  children,
  onClose,
  title,
}: {
  children: ReactChild;
  onClose: MouseEventHandler<HTMLDivElement>;
  title: string;
}) => {
  return (
    <>
      <div className="PopUpDialog__background" onClick={onClose} />
      <div className="PopUpDialog">
        <h1 className={classNames("PopUpDialog__header")}>{title}</h1>
        <div className="PopUpDialog__container">{children}</div>
      </div>
    </>
  );
};

export default PopUpDialog;
